import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './vistas/Home';
import About from './vistas/About';
import Contact from './vistas/Contact';
import Usuarios from './vistas/usuarios/Usuarios';
import Navigation from './modulos/Navbar/Nav';
import Menu from './modulos/Menu/Menu';
import Login from './vistas/Login';
import Almacenes from './vistas/almacen/Almacenes';
import Calidades from './vistas/calidades/Calidades';
import Categorias from './vistas/categorias/Categorias';
import Especies from './vistas/especies/Especies';
import IncoTerms from './vistas/incoterm/IncoTerms';
import Medidas from './vistas/medidas/Medidas';
import Productos from './vistas/productos/Productos';
import Puertos from './vistas/puertos/Puertos';
import SubClientes from './vistas/subclientes/SubClientes';
import Documentos from './vistas/documentos/Documentos';
import Clientes from './vistas/cliente/Clientes';
import Proveedores from './vistas/proveedores/Proveedores';
import CartasCredito from './vistas/cartascreditos/CartasCredito';
import LineasCredito from './vistas/lineascreditos/LineasCredito';
import ShippingDocs from './vistas/shippingdocs/ShippingDocs';
import Proformas from './vistas/proforma/Proformas';
import OrdenesCompra from './vistas/ordenescompras/OrdenesCompra';
import PaymentTerms from './vistas/paymentterms/PaymentTerms';
import SubirArchivos from './vistas/lector/SubirArchivo';
import NotasFiscales from './vistas/notasfiscale/NotasFiscales';
import FFW from './vistas/freightforwarder/FFW';
import Carriers from './vistas/carrier/Carriers';
import SolicitudesBooking from './vistas/solicitudesbooking/SolicitudesBooking';
import SolicitudesBookingInternas from './vistas/solicitudesinternas/SolicitudesBookingInternas';
import PreciosFletesYTasas from './vistas/solicitudesbooking/PreciosFletesYTasas';
import ControlEmbarques from './vistas/controlembarques/ControlEmbarques';
import { getEnvironmentBannerLabel } from './vistas/utiles';
import Invoice from './vistas/Invoice';
import Inventario from './vistas/inventario/Inventario';
import InventarioPackingLists from './vistas/inventario/InventarioPackingLists';
import FinanzasProveedores from './vistas/finanzas/FinanzasProveedores';
import { hasValidSession, clearSessionStorage } from './auth/session';


const menuItems = {
    home: [{ label: 'Home', href: '/home' }],
    file: [{ label: 'Cargar Archivos', href: '/file' }],
    generate: [
      { label: 'Ordenes Compra', href: '/ordenescompras' },
      { label: 'Proformas Invoice', href: '/proforma' },
      { label: 'Invoice', href: '/invoice' },
    ],
    records: [
      { label: 'Almacenes', href: '/almacen' },
      { label: 'Cartas de crédito', href: '/cartascreditos' },
      { label: 'Clientes', href: '/cliente' },
      { label: 'IncoTerms', href: '/incoterm' },
      { label: 'Línea de Crédito', href: '/lineascreditos' },
      { label: 'Notas Fiscales', href: '/notasfiscale' },
      { label: 'Productos', href: '#', subItems: [
          { label: 'Calidades', href: '/calidad' },
          { label: 'Categorias', href: '/categoria' },
          { label: 'Especies', href: '/especie' },
          { label: 'Medidas', href: '/medida' },
          { label: 'Productos', href: '/producto' }
        ]},
      { label: 'Payment Terms', href: '/paymentterm' },
      { label: 'Proveedores', href: '/proveedores1' },
      { label: 'Puertos', href: '/puerto' },
      { label: 'Documentos de Embarque', href: '/shippingdoc' },
      { label: 'Sub-Clientes', href: '/subcliente' },
      { label: 'Tipos de Documentos', href: '/documentos1' },
      { label: 'Usuarios', href: '/usuariosVista' }
    ],
    purchases: [
      { label: 'Proveedores', href: '/proveedor' },
      { label: 'Notas Fiscales', href: '/notas' },
      { label: 'Productos x Notas Fiscales', href: '/productonf' },
    ],
    logistics: [
      { label: 'Inventario', href: '/inventario' },
      { label: 'Packing List', href: '/packinglist' },
      { label: 'Solicitudes Internas', href: '/solicitudesinterna' },
      { label: 'Gestión de Booking', href: '/solicitudes' },
      { label: 'Tasas y Fletes', href: '/precios-fletes-tasas' },
    ],
    finance: [{ label: 'Proveedores', href: '/finanzas/proveedores' }],
    sales: [
      { label: 'Notas Fiscales', href: '/notasptb' },
      { label: 'Productos x Notas Fiscales', href: '/ptbnf' },
    ],
    dues: [{ label: 'DUE\'S', href: '/dues' }],
    invoices: [{ label: 'Invoices', href: '/invoices' }],
};
  
const getCurrentMenu = (pathname) => {
    if (pathname.startsWith('/home')) return menuItems.home;
    if (pathname.startsWith('/inventario') || pathname.startsWith('/packinglist') || pathname.startsWith('/solicitudesinterna') || pathname.startsWith('/solicitudes') || pathname.startsWith('/precios-fletes-tasas')) return menuItems.logistics;
    if (pathname.startsWith('/finanzas')) return menuItems.finance;
    if (pathname.startsWith('/file')) return menuItems.file;
    if (pathname.startsWith('/ordenescompras') || pathname.startsWith('/proforma') || pathname.startsWith('/invoice')) return menuItems.generate;
    if (pathname.startsWith('/almacen') || pathname.startsWith('/cartascreditos') || pathname.startsWith('/cliente') || pathname.startsWith('/incoterm') || pathname.startsWith('/lineascreditos') || pathname.startsWith('/calidad') || pathname.startsWith('/categoria') || pathname.startsWith('/especie') || pathname.startsWith('/medida') || pathname.startsWith('/producto') || pathname.startsWith('/proveedores1') || pathname.startsWith('/puerto') || pathname.startsWith('/shippingdoc') || pathname.startsWith('/subcliente') || pathname.startsWith('/documentos1') || pathname.startsWith('/paymentterm') || pathname.startsWith('/usuariosVista')) return menuItems.records;
    if (pathname.startsWith('/proveedor') || pathname.startsWith('/notas') || pathname.startsWith('/productonf')) return menuItems.purchases;
    if (pathname.startsWith('/notasptb') || pathname.startsWith('/ptbnf')) return menuItems.sales;
    if (pathname.startsWith('/dues')) return menuItems.dues;
    if (pathname.startsWith('/invoices')) return menuItems.invoices;
    return [];
};

const AppContent = () => {
    const [menuExpanded, setMenuExpanded] = useState(true);
    const [selectedMenu, setSelectedMenu] = useState([]);
    const [isAuthenticated, setIsAuthenticated] = useState(hasValidSession());
    const location = useLocation();
	

  useEffect(() => {
    document.title = 'ERP - Palm Trade Chile';
  }, []);

    useEffect(() => {
        const checkSession = () => {
            const ok = hasValidSession();
            if (!ok) clearSessionStorage();
            setIsAuthenticated(ok);
        };

        checkSession();
        window.addEventListener('focus', checkSession);
        window.addEventListener('storage', checkSession);
        window.addEventListener('session:ended', checkSession);

        return () => {
            window.removeEventListener('focus', checkSession);
            window.removeEventListener('storage', checkSession);
            window.removeEventListener('session:ended', checkSession);
        };
    }, []);


    useEffect(() => {
        setSelectedMenu(getCurrentMenu(location.pathname));
      }, [location.pathname]);
    
    const handleHoverChange = (isExpanded) => {
      setMenuExpanded(isExpanded);
    };

    const envBanner = getEnvironmentBannerLabel();
    const envRibbonText = envBanner?.includes('DESARROLLO')
        ? 'DESARROLLO'
        : envBanner?.includes('PRUEBAS')
            ? 'QA'
            : envBanner;

    return(
        <div className={isAuthenticated ? 'erp' : 'login'}>
            {envBanner && (
                <div
                    role="status"
                    aria-label={`Entorno ${envBanner}`}
                    style={{
                        position: 'fixed',
                        top: '34px',
                        left: '-56px',
                        zIndex: 11000,
                        width: '220px',
                        transform: 'rotate(-45deg)',
                        transformOrigin: 'center',
                        background: '#b91c1c',
                        color: '#fff',
                        fontSize: '12px',
                        fontWeight: 700,
                        letterSpacing: '0.08em',
                        lineHeight: 1.1,
                        padding: '6px 8px',
                        textAlign: 'center',
                        boxSizing: 'border-box',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.35)',
                        pointerEvents: 'none',
                    }}
                >
                    {envRibbonText}
                </div>
            )}
            <div className='app-container' style={{ marginLeft: menuExpanded && isAuthenticated ? '200px' : isAuthenticated ? '70px' : '0px', transition: 'margin-left 0.3s' }}>
                {isAuthenticated &&
                    <Navigation onToggleMenu={handleHoverChange} selectedMenu={selectedMenu} />
                }
                {isAuthenticated && 
                    <Menu onHoverChange={handleHoverChange} />
                }
                <div className='content-container'>
                    <Routes>
                        {isAuthenticated ? (
                            <>
                                <Route path="/" element={<Navigate to="/home" replace />} />
                                <Route path="/home" element={<Home />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path='/file' element={<SubirArchivos />} />
                                <Route path="/usuariosVista" element={<Usuarios />} />
                                <Route path="/almacen" element={<Almacenes />} />
                                <Route path="/calidad" element={<Calidades />} />
                                <Route path="/categoria" element={<Categorias />} />
                                <Route path="/especie" element={<Especies />} />
                                <Route path="/incoterm" element={<IncoTerms />} />
                                <Route path="/medida" element={<Medidas />} />
                                <Route path="/producto" element={<Productos />} />
                                <Route path="/puerto" element={<Puertos />} />
                                <Route path="/subcliente" element={<SubClientes />} />
                                <Route path="/documentos1" element={<Documentos />} />
                                <Route path="/cliente" element={<Clientes />} />
                                <Route path="/proveedores1" element={<Proveedores />} />
                                <Route path="/cartascreditos" element={<CartasCredito />} />
                                <Route path="/lineascreditos" element={<LineasCredito />} />
                                <Route path="/shippingdoc" element={<ShippingDocs />} />
                                <Route path="/proforma" element={<Proformas />} />
                                <Route path="/invoice" element={<Invoice />} />
                                <Route path="/ordenescompras" element={<OrdenesCompra />} />
                                <Route path="/paymentterm" element={<PaymentTerms />} />
                                <Route path="/notasfiscale" element={<NotasFiscales />} />
                                <Route path="/carrier" element={<Carriers />} />
                                <Route path="/ffws" element={<FFW />} />
                                <Route path='/solicitudes' element={<SolicitudesBooking />} />
                                <Route path='/precios-fletes-tasas' element={<PreciosFletesYTasas />} />
                                <Route path='/control-embarques' element={<ControlEmbarques />} />
                                <Route path='/solicitudesinterna' element={<SolicitudesBookingInternas />} />
                                <Route path='/inventario' element={<Inventario />} />
                                <Route path='/packinglist' element={<InventarioPackingLists />} />
                                <Route path='/finanzas/proveedores' element={<FinanzasProveedores />} />
                                <Route path="*" element={<Navigate to="/home" replace />} />
                            </>
                        ) : (
                            <>
                                <Route path="/" element={<Login />} />
                                <Route path="*" element={<Navigate to="/" replace />} />
                            </>
                        )}
                    </Routes>
                </div>
            </div>
        </div>
    )
}

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;
